import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LoadTop = () => {
  const { pathname } = useLocation();

  // scroll to : 0 takes us all the way back to the top of the page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default LoadTop;
